import { SortOrder } from '../../../components/GRTable/GRTable'

export enum MarketShareSortColumnId {
  Name = 'name',
  Q1Revenue = 'q1-revenue',
  Q1RevenueChange = 'q1-revenue-change',
  Q1Downloads = 'q1-downloads',
  Q1DownloadsChange = 'q1-downloads-change',
  Q2Revenue = 'q2-revenue',
  Q2RevenueChange = 'q2-revenue-change',
  Q2Downloads = 'q2-downloads',
  Q2DownloadsChange = 'q2-downloads-change',
}

export type MarketShareSort = {
  columnId: MarketShareSortColumnId
  sortOrder: SortOrder
}

export const defaultMarketShareSort: MarketShareSort = {
  columnId: MarketShareSortColumnId.Q1Revenue,
  sortOrder: SortOrder.DESC,
}
